'use client'
import React, { useEffect, useState } from 'react'
import cls from 'classnames'
import ReactDOM from 'react-dom'
import styles from './styles.module.scss'

export type TMaskProps = {
  open: boolean
  width?: number
  className?: string
  showCloseBtn?: boolean
  showBackBtn?: boolean
  closeOnMaskClick?: boolean
  title?: string | React.ReactNode
  transitionDuration?: number
  onClose?: () => void
  footer?: React.ReactNode
  children: React.ReactNode
  phoneRightSlog?: ((onClose: () => void) => React.ReactNode) | React.ReactNode
}

export default function Mask(props: TMaskProps) {
  const { onClose, open } = props
  const [visible, setVisible] = useState(props.open)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setVisible(open)
    }, props.transitionDuration || 200)
  }, [open, props.transitionDuration])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }

    if (open) {
      document.addEventListener('keydown', handleKeyDown)
    } else {
      document.removeEventListener('keydown', handleKeyDown)
    }

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  const modalContent = (
    <div
      className={cls(props.className || styles.mask, styles.maskOverlay, {
        mask__show: open,
      })}
    >
      <div
        className="mask__overlay"
        onClick={() => {
          if (props.closeOnMaskClick ?? true) {
            props.onClose?.()
          }
        }}
      />
      <div
        className="mask__main"
        style={{
          transitionDuration: `${props.transitionDuration}ms`,
          width: props.width,
        }}
      >
        {visible || open ? (
          <>
            {(props.showCloseBtn || props.showBackBtn || props.title) && (
              <div className="mask__header">
                {props.showBackBtn && (
                  <button onClick={props.onClose} className="mask__headerBack rotate-[225deg]">
                    <i className="iconfont iconn-jiantoutiaozhuan1 c8" />
                  </button>
                )}
                {props.title && <h2>{props.title}</h2>}
                {props.showCloseBtn && (
                  <button onClick={props.onClose} className="mask__headerClose">
                    <i className="iconfont iconguanbi c8" />
                  </button>
                )}
                {props.phoneRightSlog && (
                  <div className="mask__headerRight">
                    {typeof props.phoneRightSlog === 'function'
                      ? props.phoneRightSlog(() => props.onClose?.())
                      : props.phoneRightSlog}
                  </div>
                )}
              </div>
            )}
            <div className="mask__body">{props.children}</div>
            {props.footer && <div className="mask__footer">{props.footer}</div>}
          </>
        ) : null}
      </div>
    </div>
  )
  if (!isClient) {
    return null
  }
  return ReactDOM.createPortal(modalContent, document.body)
}
